var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    _vm._l(_vm.countryData, function (item, sectionIndex) {
      return _c(
        "Accordion",
        {
          key: sectionIndex,
          attrs: {
            full: true,
            active: true,
            "dir-button": true,
            title: item.title,
          },
        },
        [
          _c(
            "div",
            { staticClass: "main__featured section section-border--top" },
            [
              _c(
                "client-only",
                [
                  _c("ReportSlider", {
                    attrs: {
                      slides: item.jurisdictions,
                      "slide-nav": _vm.jurisdictionNavItems,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }